import React from 'react';

const generateArrModal = ({ title }) => ({
  title,
  body: (
    <div>
      <p>
        The arrival time is the universal coordinated time of the arrival of the maximum tsunami wave at the location of the effects given in Day, Hour and Minutes.
      </p>
    </div>
  ),
});

export const RuMaxArrDayModal = generateArrModal({ title: 'Maximum Wave Arrival Time - Day' });
export const RuMaxArrHourModal = generateArrModal({ title: 'Maximum Wave Arrival Time - Hour' });
export const RuMaxArrMinuteModal = generateArrModal({ title: 'Maximum Wave Arrival Time - Minutes' });
